import { FaBars } from 'react-icons/fa';
import {
    MobileIcon,
    Nav,
    NavbarContainer,
    NavLogo,
    NavMenu,
    NavItem,
    NavBtn,
    NavBtnLink,
    NavLinkTo
} from './NavbarElements';
import { useEffect, useState } from 'react';
import { animateScroll as scroll} from 'react-scroll';
import Logo from '../../images/tax-file-app-logo.png';



const NavbarForms = ({ toggle }) => {
    const [scrollNav, setScrollNav] = useState(false);

    const changeNav = () => {
        if(window.scrollY >= 80) {
            setScrollNav(true)
        } else {
            setScrollNav(false)
        }
    }

    useEffect(() => {
        return () => {
            window.addEventListener('scroll', changeNav)
        };
    }, []);

    const toggleHome = () => {
        scroll.scrollToTop();
    }

    return (
        <>
            <Nav scrollNav={scrollNav}>
                <NavbarContainer>
                    <NavLogo to="/" onClick={toggleHome}>
                        <img src={Logo} alt="Tax File App Logo" width="200px" />
                    </NavLogo>

                    <MobileIcon onClick={toggle}>
                        <FaBars />
                    </MobileIcon>

                    <NavMenu>
                        <NavItem>
                            <NavLinkTo href="/">Home</NavLinkTo>
                        </NavItem>
                        <NavItem>
                            <NavLinkTo href="/1099-forms">1099</NavLinkTo>
                        </NavItem>
                        <NavItem>
                            <NavLinkTo href="/w2-forms">W2</NavLinkTo>
                        </NavItem>
                        <NavItem>
                            <NavLinkTo href="/payroll-forms">Payroll</NavLinkTo>
                        </NavItem>
                        <NavItem>
                            <NavLinkTo href="/aca-forms">ACA</NavLinkTo>
                        </NavItem>
                        <NavItem>
                            <NavLinkTo href="/tax-extensions">Extensions</NavLinkTo>
                        </NavItem>
                    </NavMenu>

                    <NavBtn>
                        <NavBtnLink id="sign-up" href="https://taxfileapp.securetaxfilings.com/register">
                            Signup / Login
                        </NavBtnLink>
                    </NavBtn>
                </NavbarContainer>
            </Nav>
        </>
    );
};

export default NavbarForms;
